import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
/*
 * ── Stylesheets FIRST, and in this order ───────────────────────────────────
 *
 * ES module imports are evaluated in source order, and a component's own
 * `import './x.css'` is pulled in when that component is evaluated. `App` was
 * imported above the stylesheets and imports worx.css itself — so worx.css
 * landed in the bundle BEFORE index.css, and core quietly won every rule the
 * two files disagreed about. The symptom was a button that stayed full width
 * no matter how specific the override got, which reads as a specificity
 * problem and is not one.
 *
 * All three are listed here, ahead of any component, so the cascade is a fact
 * of this file rather than a side effect of import order somewhere else.
 */
import './index.css'
import './worx/theme.css'
import './worx/worx.css'
import './worx/glow.css'

import { Capacitor } from '@capacitor/core'
import App from './App'
import { installErrorCapture } from './lib/errors'
import { installDebugLog } from './lib/debuglog'

// Installed FIRST, before anything else can throw. An error during boot is
// exactly the one worth capturing, and it is the one a later install misses.
// Marks the page when it is running inside the native iOS app, so layout can differ
// there (one column in the app; two on a wide desktop browser).
if (Capacitor.isNativePlatform()) document.documentElement.dataset.native = 'true'
installErrorCapture()
// Second, so the console tee is in place before anything else logs. The run-up
// to a failure is usually where the answer is.
installDebugLog()

/*
 * The service worker asks for the subscription id over a MessagePort, because a
 * worker cannot read localStorage. Registered here so the answer is available as
 * soon as a tab is open.
 */
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js').catch(() => {
    // No service worker means no push. The app still works; the inbox still works.
  })
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'subscriptionId') {
      event.ports[0]?.postMessage(localStorage.getItem('subscriptionId'))
    }
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
